import config from 'Cloud/config';
import { ACTION_PROMO } from 'reactApp/appHelpers/configHelpers';
import { renderBuyModal } from 'reactApp/components/BuyModal/renderBuyModal';
import { renderOldTariffsDialog } from 'reactApp/components/OldTariffsView/OldTariffsDialogToolkit';
import { openFastCheckout as openFastCheckoutAction } from 'reactApp/modules/payment/payment.module';
import { productsController } from 'reactApp/modules/products/products.controller';
import { updateProducts } from 'reactApp/modules/products/products.module';
import { waitForUserUpdate } from 'reactApp/modules/user/waitForUserUpdate';
import { store } from 'reactApp/store';
import { noopVoid } from 'reactApp/utils/helpers';
import { openSubscriptionsPage } from 'reactApp/utils/openHelpers';

const BILLING_ENABLED = config.get('user.cloud.billing.enabled');
const IS_ACTION_USER = config.get('IS_ACTION_USER');
const GO_TO_SUBSCRIPTIONS_ENABLED = IS_ACTION_USER && !!ACTION_PROMO;

const openFastCheckout = ({ productId, onSuccess = noopVoid, afterUpdate = noopVoid }) => {
    return new Promise((resolve) => {
        const afterUpdateCallback = () => {
            afterUpdate();
            resolve(true);
        };

        const onClose = () => {
            resolve(false);
        };

        store.dispatch(
            openFastCheckoutAction({
                productId,
                onSuccess,
                onClose,
                afterUpdate: afterUpdateCallback,
            })
        );
    });
};

const openTariffs = ({ onSuccess = noopVoid, onProductSelect = noopVoid }) => {
    return new Promise((resolve) => {
        const onSuccessCallback = () => {
            onSuccess();
            resolve(true);
        };

        const onClose = () => {
            resolve(false);
        };

        renderOldTariffsDialog({
            onSuccess: onSuccessCallback,
            onClose,
            onProductSelect,
        });
    });
};

const openTariff = ({ id, onSuccess, afterUpdate = noopVoid }) => {
    return new Promise((resolve) => {
        const onSuccessCallback = () => {
            onSuccess();
            store.dispatch(updateProducts());
            waitForUserUpdate().then(() => {
                afterUpdate();
                resolve(true);
            });
        };

        const onClose = () => {
            resolve(false);
        };

        renderBuyModal({
            id,
            onSuccess: onSuccessCallback,
            onClose,
        });
    });
};

export const requestPayment = ({
    tariff,
    productId,
    showTariffList,
    forceFastCheckout,
    onProductSelect = noopVoid,
    onSuccess = noopVoid,
    afterUpdate = noopVoid,
    goToSubscriptions = openSubscriptionsPage,
    isMobile = false,
} = {}) => {
    if (!BILLING_ENABLED) {
        return Promise.resolve();
    }

    if (isMobile) {
        goToSubscriptions({ inSameTab: true, query: tariff ? `action=request-payment&productId=${tariff}` : '' });
        return Promise.resolve();
    }

    if (GO_TO_SUBSCRIPTIONS_ENABLED && !tariff && !forceFastCheckout) {
        goToSubscriptions({ inSameTab: true, anchor: 'special' });
        return Promise.resolve();
    }

    return productsController
        .loadProducts()
        .then(() => {
            if (productId) {
                return openTariff({ id: productId, onSuccess, afterUpdate });
            }

            if (!showTariffList || tariff) {
                return openFastCheckout({ productId: tariff, afterUpdate });
            }

            return openTariffs({ onSuccess, onProductSelect });
        })
        .catch(() => openTariffs({}));
};
